<template>
    <div class="w-100 h-100">
        <transition name="page-custom" mode="out-in" :key="$router.currentRoute.fullPath">
            <router-view> </router-view>
        </transition>
    </div>
</template>

<script>
export default {
    name: "EmptyLayout"
}
</script>

<style scoped>

</style>